import React from "react";
import "./TalkCard.scss";

export default function TalkCard({ talkDetails }) {
  const handleClick = () => {
    window.open(talkDetails.connect_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="container">
      <div
        className={talkDetails.isDark ? "dark-rectangle rectangle" : "rectangle"}
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className="diagonal-fill"></div>
        <div className="talk-card-title">{talkDetails.title}</div>
        <p className="talk-card-subtitle">{talkDetails.subtitle}</p>

        <div className="card-footer-button-div">
          <div className="talk-button">Connect</div>
        </div>
      </div>
    </div>
  );
}